import { Group } from '@mantine/core';
import { IconCalendarEvent, IconFilter, IconMessageCircle } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import ActionIconWithText from './ActionIconWithText';
import InboxIconWithIndicator from './InboxIconWithIndicator';
import ListCheckIconWithIndicator from './ListCheckIconWithIndicator';

interface HandlersProps {
  filter: () => void;
}

const PrimaryFooter: FC<HandlersProps> = ({ filter }) => {
  const { openWidget } = useConversationsWidget();
  const { unreadMessagesProps } = useContext(ProfileContext);
  const { unreadCount } = unreadMessagesProps ?? { unreadCount: 0 };
  const navigate = useNavigate();

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText label="Filter" onClick={filter} useDefaultWidth>
        <IconFilter />
      </ActionIconWithText>
      <ActionIconWithText label="Events" useDefaultWidth onClick={() => navigate('/')}>
        <IconCalendarEvent />
      </ActionIconWithText>
      <ActionIconWithText label="Aufgaben" onClick={() => navigate('/tasks')} useDefaultWidth>
        <ListCheckIconWithIndicator />
      </ActionIconWithText>
      <ActionIconWithText useDefaultWidth label="Postfach" onClick={() => navigate('/postbox/inbox')}>
        <InboxIconWithIndicator unreadCount={unreadCount} />
      </ActionIconWithText>
      <ActionIconWithText label="Support" onClick={openWidget} useDefaultWidth>
        <IconMessageCircle />
      </ActionIconWithText>
    </Group>
  );
};

export default PrimaryFooter;
